import React from 'react';
import { FaPlus } from 'react-icons/fa';

function CreateButton({ onClick }) {
  return (
    <div className="create-button-container">
      <button
        className="action-button"
        onClick={onClick}
      >
        <FaPlus /> Create
      </button>
    </div>
  );
}

export default CreateButton; 